export default "__VITE_ASSET__DWWFbyBa__"